import photoConfig from 'ui-theme/widgets/axel-publication-content/js/config';

const config = photoConfig;
config.mathjax.config.output = {
    ...photoConfig.mathjax.config.output,
    font: 'mathjax-fira',
};

export default config;
